import PropTypes from 'prop-types';
import React from 'react';
import { IconButton as MuiIconButton, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const IconButton = ({ icon, label, onClick }) => {
  const theme = useTheme();

  return (
    <MuiIconButton
      disableRipple
      onClick={onClick}
      sx={{
        border: `thin solid ${theme.palette.iconButton.border}`,
        borderRadius: `${theme.shape.borderRadius}px`,
        padding: '0.5rem 2rem',
        width: '100%',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
      }}
    >
      <Grid container direction="column">
        <Grid>
          {icon}
        </Grid>
        <Grid>
          <Typography
            variant="body1"
            sx={{
              fontFamily: theme.custom.romanFontFamily,
            }}
          >
            {label}
          </Typography>
        </Grid>
      </Grid>
    </MuiIconButton>
  );
};

IconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default IconButton;
